import UnicoUtils from "./script-utils.js";

/**
 * 汎用モーダル表示
 */
export default class CustomModal extends HTMLElement {
  constructor() {
    super();

    // 各種要素の取得
    this.modal = this.querySelector("dialog");
    const targetId = this.dataset.targetId;
    const modalButton = document.querySelectorAll(`[data-modal-target=${targetId}]`);
    const modalMode = this.dataset.modalMode;

    // モーダル表示処理
    modalButton.forEach((button) => {
      button.addEventListener("click", () => {
        this.modal.showModal();
        // フォーカスを持つ要素からフォーカスを外す
        document.activeElement.blur();
        setTimeout(() => {
          this.modal.classList.add('visible');
        }, 0);
      });
    });

    // 閉じるボタンのイベントを設定
    const closeButtons = this.querySelectorAll("[data-target-id=modal-close-button]");
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener("click", (e) => {

        // 確認モーダルを閉じる場合は、以下のイベントを発行する
        if (e.target.dataset.modalConfirm === 'accept') {
          if(targetId == 'account-withdrawal') {
            this.querySelector('.error').classList.add('hidden')
            const withdrawalForm = document.getElementById('withdrawal');
            const currentEmail = this.dataset.email;
            const email = withdrawalForm.querySelector('input[type="email"]').value;
            
            if (email === currentEmail) {
              this.querySelector('.error').classList.add('hidden')
              this.closeModal();
              document.querySelector('#bind-taikai-button').click();
            } else {
              this.querySelector('.error').classList.remove('hidden')
            }
          } else {
            this.closeModal();
          }
          this.dispatchEvent(new Event('confirm-accept'));
        } else if (e.target.dataset.modalConfirm === 'dismiss') {
          this.closeModal();
          this.dispatchEvent(new Event('confirm-dismiss'));
        } else {
          this.closeModal();
        }
      });
    });

    // モーダル外クリックの判定
    this.modal.addEventListener('click', (event) => {
      if (modalMode === 'alert' || modalMode === 'confirm') return;
      const rect = this.modal.getBoundingClientRect();
      if (
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom
      ) {
        this.closeModal();
      }
    });

    // テーブルスクロール処理
    document.addEventListener("DOMContentLoaded", () => this.observeScrolled());
    window.addEventListener("resize", () => this.observeScrolled());
  }

  /**
   * モーダルを非表示
   */
  closeModal() {
    this.modal.close();
  }

  /**
   * テーブルスクロール処理
   */
  observeScrolled() {
    const scrollContainer = this.modal.querySelectorAll(".unico-m-scroll-container-x-sp");
    if (!scrollContainer.length) return;

    scrollContainer.forEach(function(container) {
      if (UnicoUtils.isSP()) {
        container.addEventListener("scroll", function() {
          if (container.scrollLeft > 0) {
            container.classList.add("is-scrolled");
          } else {
            container.classList.remove("is-scrolled");
          }
        });
      } else {
        container.classList.remove("is-scrolled");
      }
    });
  }
}
